require("core-js/modules/es.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.entRouter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var ent = {
    path: '/ent',
    redirect: '/ent/tgjRas/:id',
    name: 'DeviceList',
    component: function component() {
      return import('@/Layout');
    },
    meta: {
      title: '塘管家数字化养殖管理中心'
    },
    children: [{
      path: '/ent/tgjRas/:id',
      component: function component() {
        return import('@/pages/ent/tgjRasPlatform');
      },
      name: 'TgjRasPlatform',
      meta: {
        title: '塘管家数字化养殖管理中心'
      }
    }]
  };
  var _default = ent;
  _exports.default = _default;
});